import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import store from "../store"
import {mapGetters, mapActions} from 'vuex'

Vue.use(Router)

const router = new Router({
  routes: routes,
  // mode: 'history'
})
router.beforeEach((to, from, next) => {
  if (to.path === '/home' || to.path === '/sh') {
    next()
  } else {
    let userData = store.getters.user
    if (userData === null) {
      next('/home')
    } else {
      next()
    }
  }
})
// router.afterEach(to => {
// })

export default router
